/** Names and one-line descriptions per registry key; a key without an entry shows its key. */
export const BETA_FEATURE_COPY: Record<string, { label: string; description: string }> = {
  DESIGN_SYSTEM_SHOWCASE: {
    label: "Design system showcase",
    description: "Browse the shared interface components.",
  },
  SENSITIVITY_REVIEW: {
    label: "Data sensitivity review",
    description: "Review and decide how sensitive each column is.",
  },
};

export const BETA_COPY = {
  account: {
    title: "Beta features",
    cardTitle: "Try early features",
    effectNote: "A change takes effect the next time the page loads.",
    empty: "Your organization has not turned on any beta features for members yet.",
    loading: "Loading beta features",
    errorTitle: "Beta features could not be loaded",
  },
  org: {
    title: "Beta features",
    cardTitle: "Members can turn these on",
    rowSuffix: "Members can turn this on",
    loading: "Loading beta features",
    errorTitle: "Beta features could not be updated",
    unavailableTitle: "Choose which beta features members can use",
    unavailableDetail: "Available after the next update",
  },
} as const;
